<template>
  <div class="select">
    <div class="select-checked">
      <span>已选择</span>
      <span class="select-checked-num">{{ num }}</span>
      <span>个{{ text }}</span>
    </div>
    <div>
      <bi-button type="blueText" @click="choose">选择{{ text }}</bi-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "YSelectItem",
  props: {
    num: {
      type: Number,
      default: 0,
    },
    text: {
      type: String,
      default: "地区",
    },
  },
  methods: {
    choose() {
      this.$emit("choose");
    },
  },
};
</script>

<style lang="scss" scoped>
.select {
  height: 30px;
  border: 1px solid #efefef;
  background: #fff;
  width: 100%;
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding: 4px;
  &-checked {
    height: 100%;
    display: flex;
    align-items: center;
    background-color: #f5f5f5;
    border-radius: 2px;
    padding: 4px 8px;
    margin-right: 8px;
    &-num {
      color: #fe7622;
      margin: 0px 6px;
    }
  }
}
</style>
